/** Umbrella experiment that gates whether the editor VSM engine is available. */
export const VSM_EDITOR_EXPERIMENT = 'specs.thunderbolt.vsm_editor' as const

/** Shared experiment that converts every registered editor feature from Carmi to VSM. */
export const VSM_EDITOR_CONFIGS_EXPERIMENT = 'specs.thunderbolt.vsmEditorConfigs' as const
